import { put, call } from "redux-saga/effects";
import { episodeConstants } from "../actions/constants/episodeConstants";
import { EpisodeService } from "../services/api/episodeService";
import { exceptionHandler } from "../pages/common/functions";
import { ChannelService } from "../services/api/channelService";

function* episodeSave(request: any) {
	try {
		const result = yield call(EpisodeService.episodeSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeSaveFailure, payload: res.data });
		}

	} catch (error) {
		yield put({ type: episodeConstants.EpisodeSaveFailure, payload: error });
	}
}

function* episodeGetDetail(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetDetail, request.input);		
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetDetailSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetDetailFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetDetailFailure, payload: error });
	}
}

function* episodeGetDropdownList() {
	try {
		const episodeTypeResult = yield call(EpisodeService.episodeTypeGetByFilter);
		const channelResult = yield call(ChannelService.channelGetByfilter);
		const bookMarkTypeResult = yield call(EpisodeService.bookMarkTypeGetByFilter)

		var resEpisodeType = exceptionHandler(episodeTypeResult);
		var resChannel = exceptionHandler(channelResult);
		var resBookmarkType = exceptionHandler(bookMarkTypeResult);

		if (resEpisodeType.status && resChannel.status && resBookmarkType.status) {
			yield put({
				type: episodeConstants.EpisodeGetDropdownSuccess,
				channel: resChannel.data,
				episodeType: resEpisodeType.data,
				bookMarkType: resBookmarkType.data,
				status: resEpisodeType.data.status || resChannel.data.status || resBookmarkType.data.status
			});
		}
		else {
			const error = !resEpisodeType.status ? resEpisodeType.data :
								!resChannel.status ? resChannel.data : resBookmarkType.data
			yield put({
				type: episodeConstants.EpisodeGetDropdownFailure,
				payload: error
			});
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetDropdownFailure, payload: error });
	}
}

function* episodeGetByFilter(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetByFilterSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: episodeConstants.EpisodeGetByFilterFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetByFilterFailure, payload: error });
	}
}

function* episodeDelete(request: any) {
	try {
		const result = yield call(EpisodeService.episodeDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeDeleteFailure, payload: error });
	}
}

function* episodeGetReading(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetReading, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetReadingSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetReadingFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetReadingFailure, payload: error });
	}
}

function* episodeGetReadingIdByTitle(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetReadingIdByTitle, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetReadingIdSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetReadingIdFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetReadingIdFailure, payload: error });
	}
}

function* episodeGetUserCountByYear(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetUserCountByYear, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetUserCountSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetUserCountFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetUserCountFailure, payload: error });
	}
}

function* episodeGetUserEngagement(request: any) {
	try {
		const result = yield call(EpisodeService.episodeGetUserEngagement, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetUserEngagementSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetUserEngagementFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetUserEngagementFailure, payload: error });
	}
}

function* episodeGetMinDate() {
	try {
		const result = yield call(EpisodeService.episodeGetMinDate);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeGetMinDateSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetMinDateFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetMinDateFailure, payload: error });
	}
}
function* episodeGetFeed() {
	try {
		const result = yield call(EpisodeService.episodeValidateFeed);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpioseValidateFeedSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeGetDetailFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeGetDetailFailure, payload: error });
	}
}

function* episodeGetUserMetric() {
	try {
		const result = yield call(EpisodeService.getUserEpisodeMetric);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeUserMetricSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeUserMetricFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeUserMetricFailure, payload: error });
	}
}

function* episodeUpdateEngagement(request: any) {
	try {
		const result = yield call(EpisodeService.episodeUpdateEngagement, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: episodeConstants.EpisodeUpdateEngagementSuccess,
				payload: res.data,
				meta: request.meta
			});
		}
		else {
			yield put({ type: episodeConstants.EpisodeUpdateEngagementFailure, payload: res.data, meta: request.meta });
		}
	} catch (error) {
		yield put({ type: episodeConstants.EpisodeUpdateEngagementFailure, payload: error, meta: request.meta });
	}
}

export const episodeSaga = {
	episodeSave,
	episodeGetDetail,
	episodeGetDropdownList,
	episodeGetByFilter,
	episodeDelete,
	episodeGetReading,
	episodeGetReadingIdByTitle,
	episodeGetUserCountByYear,
	episodeGetUserEngagement,
	episodeGetMinDate,
	episodeGetFeed,
	episodeGetUserMetric,
	episodeUpdateEngagement
}